"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealerAssetCache = exports.bannerDataMap = void 0;
var cacheRegistryKey = 'dealerAssetCache';
if (!global.hasOwnProperty(cacheRegistryKey)) {
    global[cacheRegistryKey] = new Map();
}
exports.bannerDataMap = global[cacheRegistryKey];
exports.DealerAssetCache = {
    hasAsset: function (bannerKey) { return exports.bannerDataMap.has(bannerKey); },
    setAsset: function (bannerKey, dealerResponse) { return exports.bannerDataMap.set(bannerKey, dealerResponse); },
    getAsset: function (bannerKey) { return exports.bannerDataMap.get(bannerKey); },
    clearCache: function () { return exports.bannerDataMap.clear(); },
};
//# sourceMappingURL=DealerAssetCache.js.map